import { getVariables } from "../../variables";

export const getAdminPortalViewReportUrl = (clientCode: string, reportId: string) => {
  return `${getVariables().ADMIN_PORTAL_URI}/${clientCode}/smart-views/reports/${reportId}/view`;
};

export const getAdminPortalEditReportUrl = (clientCode: string, reportId: string) => {
  return `${getVariables().ADMIN_PORTAL_URI}/${clientCode}/smart-views/reports/${reportId}/edit`;
};

export const getAdminPortalViewApiReportUrl = (clientCode: string, reportId: string) => {
  return `${getVariables().ADMIN_PORTAL_URI}/${clientCode}/smart-views/api-reports/${reportId}/view`;
};

export const getAdminPortalEditApiReportUrl = (clientCode: string, reportId: string) => {
  return `${getVariables().ADMIN_PORTAL_URI}/${clientCode}/smart-views/api-reports/${reportId}/edit`;
};

export const getAdminPortalEditTemplateUrl = (clientCode: string, organization: string, templateId: string) => {
  return `${getVariables().ADMIN_PORTAL_URI}/${clientCode}/smart-views/templates/${organization}/${templateId}/edit`;
};
